import { createFileRoute } from "@tanstack/react-router";
import { TaskDetailScreen } from "../screens/TaskDetailScreen";

export const Route = createFileRoute("/tasks/$taskId")({
  component: TaskDetail,
});

function TaskDetail() {
  const { taskId } = Route.useParams();
  // Deliberately not cast to Id<"tasks">: it is whatever was in the URL. The
  // query decides whether it names a real task and says so by returning null.
  return <TaskDetailScreen taskId={taskId} />;
}
